import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { PackageSearch, PackageCheck } from "lucide-react";
import { api } from "@/lib/api";
import { formatNumber } from "@/lib/format";
import { useAuth } from "@/context/AuthContext";
import { fmtQty } from "@/components/backorders/BackorderTable";

export default function BackorderCards() {
  const { can } = useAuth();
  const navigate = useNavigate();
  const [d, setD] = useState(null);
  useEffect(() => { if (can("bekleyen")) api.get("/backorders/summary").then(({ data }) => setD(data)).catch(() => {}); }, []); // eslint-disable-line react-hooks/exhaustive-deps
  if (!d) return null;
  const arr = d.stock_arrived;
  return (
    <div className="grid grid-cols-1 md:grid-cols-2 gap-3 mb-3" data-testid="backorder-cards">
      <button className="panel p-3 text-left hover:border-blue-300" onClick={() => navigate("/bekleyen-siparisler")} data-testid="card-my-backorders">
        <div className="text-[11px] font-semibold uppercase tracking-wider text-slate-500 flex items-center gap-1"><PackageSearch className="h-3.5 w-3.5" />Bekleyen Siparişlerim</div>
        <div className="mt-1 font-mono text-lg font-semibold" data-testid="card-my-backorders-count">{d.mine.count} kayıt · {formatNumber(d.mine.pending_qty)} adet</div>
        {d.all && <div className="text-[11px] text-slate-500">Tüm temsilciler: {d.all.count} kayıt · {formatNumber(d.all.pending_qty)} adet · stok gelen {d.all.stock_arrived}</div>}
      </button>
      <div className={`panel p-3 ${arr.count ? "border-emerald-300 bg-emerald-50/40" : ""}`} data-testid="card-stock-arrived">
        <div className="text-[11px] font-semibold uppercase tracking-wider text-slate-500 flex items-center gap-1"><PackageCheck className="h-3.5 w-3.5" />Stok Gelen Siparişlerim</div>
        <div className="mt-1 font-mono text-lg font-semibold" data-testid="card-stock-arrived-count">{arr.count}</div>
        {arr.items.slice(0, 4).map((b) => <button key={b.id} className="block text-[12px] text-left hover:text-blue-700 truncate w-full" onClick={() => navigate(b.link)} data-testid={`card-stock-arrived-${b.id}`}>
          {b.customer_title} · {b.sku} · karşılanabilir {fmtQty(b.coverable, b.koli_ici, b.unit)}</button>)}
      </div>
    </div>
  );
}
